import { WhiteLabelRestricted } from "components/app/white-label-restricted";
import { TertiarynavMenu, TertiarynavMenuItem } from "components/navigation/tertiarynav";
import React from "react";
import { useCrmMode, useFeature } from "store/selectors/hooks";
import {
    homeCareClientsSettingsLabel,
    placementClientsSettingsLabel,
} from "util/crm-mode";

export const AgencySettingsNav: React.FC<unknown> = () => {
    const isFaxEnabled = useFeature("fax");
    const { mode, placementEnabled, homeCareEnabled } = useCrmMode();
    return (
        <TertiarynavMenu>
            <TertiarynavMenuItem to="/settings/agency/general">
                Agency Profile
            </TertiarynavMenuItem>
            {placementEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/invoices">
                    Invoices
                </TertiarynavMenuItem>
            ) : null}
            <TertiarynavMenuItem to="/settings/agency/signwise">
                SignWise
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/tasks">
                Activities &amp; Tasks
            </TertiarynavMenuItem>
            {placementEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/hosted-form">
                    Hosted Intake Form
                </TertiarynavMenuItem>
            ) : null}
            {placementEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/clients">
                    {placementClientsSettingsLabel(mode)}
                </TertiarynavMenuItem>
            ) : null}
            {homeCareEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/home-care-clients">
                    {homeCareClientsSettingsLabel(mode)}
                </TertiarynavMenuItem>
            ) : null}
            {placementEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/communities">
                    Communities
                </TertiarynavMenuItem>
            ) : null}
            <TertiarynavMenuItem to="/settings/agency/referrals">
                Referrals
            </TertiarynavMenuItem>
            <WhiteLabelRestricted>
                <TertiarynavMenuItem to="/settings/agency/lead-sources">
                    Lead Sources
                </TertiarynavMenuItem>
            </WhiteLabelRestricted>
            {placementEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/customize/cc">
                    Custom Fields
                </TertiarynavMenuItem>
            ) : null}
            {isFaxEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/fax">Fax</TertiarynavMenuItem>
            ) : null}
        </TertiarynavMenu>
    );
};
